import React from "react";
import {
  makeStyles,
  Box,
  Grid,
  Button,
  Typography,
} from "@material-ui/core";
import Dialog from "components/dialog/customDialog";
import DatePicker from "components/input/datePicker";
import { getLang } from "app/feature/constants";

const style = (theme) => ({
  datePicker: {
    width: "100%",
  },
});

const useStyles = makeStyles(style);

export default function EditWarrantyDialogComponent({
  isOpen,
  handleClose,
  purchaseDate,
  onDateChange,
  handleSubmit,
  lang,
}) {
  const classes = useStyles();

  return (
    <Dialog
      isOpen={isOpen}
      handleClose={handleClose}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableEscapeKeyDown={true}
      disableBackdropClick={true}
      PaperProps={{ style: { borderRadius: "10px" } }}
    >
      <Box p={4} py={3} minWidth={350}>
        <Typography variant="h6" gutterBottom color="primary">
          <Box fontWeight="fontWeightBold">
            {getLang(lang, "label.EDIT_WARRANTEE")}
          </Box>
        </Typography>

        <Box py={2}>
          <Typography variant="body2" color="primary">
            {getLang(lang, "label.DATE_OF_PURCHASE")}
          </Typography>
          <DatePicker
            format="DD MMM YYYY"
            value={purchaseDate}
            onChange={onDateChange}
            InputPropStyle={{ width: "100%" }}
            classes={{ root: classes.datePicker }}
            label=""
          />
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleClose}
            >
              {getLang(lang, "label.CANCEL")}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={handleSubmit}
            >
              {getLang(lang, "label.SAVE")}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
} 